// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ein: CountryValidator<"US"> = createValidator(
  "us.ein",
  168,
);

export default ein;
export const compact = ein.compact;
export const format = ein.format;
export const validate = ein.validate;
export const generate = (): string =>
  ein.generate?.() ??
  (() => {
    throw new Error(
      "Validator us.ein cannot generate values",
    );
  })();
